import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.uploaded_report_list, { type, payload }) {
    switch (type) {
        case types.PATIENT_UPLOADED_REPORT_LIST_REQUEST:
            return {
                ...initialState.uploaded_report_list,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.PATIENT_UPLOADED_REPORT_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.PATIENT_UPLOADED_REPORT_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}